// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment_prod = {
		 production: true,
    name: 'prod',
    override: null,
    api: {
      authentication: {
        url: 'https://infinity.hcch.com/QARAuthentication/'
      },
      qar: {
        url: 'https://infinity.hcch.com/QAR/'
      }
    },
    okta: {
      issuer: 'https://hcc.okta.com/oauth2/aus24623wbxF6C1t41d8',
      redirectUri: 'https://qarportal.tmhcc.com/implicit/callback',
      loginUri: 'https://qarportal.tmhcc.com/',
      clientId: '0oa2461zqmc4U2f8N1d8',
      pkce: true
}
}
;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
